/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface PersonnelTutelleSearch
 */
export interface PersonnelTutelleSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof PersonnelTutelleSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof PersonnelTutelleSearch
     */
    independant?: BooleanSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PersonnelTutelleSearch
     */
    email?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof PersonnelTutelleSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonnelTutelleSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof PersonnelTutelleSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof PersonnelTutelleSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PersonnelTutelleSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof PersonnelTutelleSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PersonnelTutelleSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the PersonnelTutelleSearch interface.
 */
export function instanceOfPersonnelTutelleSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PersonnelTutelleSearchFromJSON(json: any): PersonnelTutelleSearch {
    return PersonnelTutelleSearchFromJSONTyped(json, false);
}

export function PersonnelTutelleSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonnelTutelleSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'independant': !exists(json, 'independant') ? undefined : BooleanSearchFromJSON(json['independant']),
        'email': !exists(json, 'email') ? undefined : TextSearchFromJSON(json['email']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function PersonnelTutelleSearchToJSON(value?: PersonnelTutelleSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': TextSearchToJSON(value.code),
        'independant': BooleanSearchToJSON(value.independant),
        'email': TextSearchToJSON(value.email),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

